<template>
  <div>
    <WdsStack v-if="attachments.length <= 0" direction-row justify-center>
      <WdsText secondary>{{ $t('No documents.') }}</WdsText>
    </WdsStack>
    <WdsStack
      v-for="attachment in attachments"
      :key="attachment.id"
      direction-row
      align-center
      justify-space-between
      gap-sm
    >
      <WdsIcon name="document" :size="16" class="tw-shrink-0" />

      <a
        :href="laravelNamedRoute(namedRoutes.files.download, { fileId: attachment.id })"
        class="tw-font-medium tw-grow tw-line-clamp-1 tw-break-all"
        :data-test="`job-attachment-${attachments.indexOf(attachment)}`"
        target="_blank"
        :title="attachment.name"
      >
        {{ attachment.name }}
      </a>

      <WdsButtonGhost
        :data-test="`job-attachment-remove-${attachments.indexOf(attachment)}`"
        @click="removeAttachment(attachment.id)"
      >
        <WdsIcon name="close" :size="16" class="tw-text-gray-600" />
      </WdsButtonGhost>
    </WdsStack>
    <WdsStack direction-row justify-end class="tw-mt-4">
      <PickerFileFilebank
        v-slot="{ openFilePicker }"
        :exclude-ids="attachments.map(({ id }) => id)"
        use-global-id
        @files-selected="updateAttachments"
      >
        <WdsButtonGhost
          primary
          :disabled="loading"
          data-test="job-attachment-add"
          @click="openFilePicker"
        >
          <WdsStack align-center>
            <WdsIcon name="plus" :size="18" />
            {{ $t('Add documents useful for candidates') }}
          </WdsStack>
        </WdsButtonGhost>
      </PickerFileFilebank>
    </WdsStack>
  </div>
</template>

<script setup lang="ts">
import { WdsStack, WdsIcon, WdsButtonGhost, WdsText } from '@worksome/wds-components'

import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import PickerFileFilebank from '@/components/PickerFileFilebank.vue'
import { Attachment } from '@/components/Attachments/attachment-types'

const emit = defineEmits(['update:attachments'])

interface Props {
  loading?: boolean
  attachments: Attachment[]
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
  attachments: () => [] as Attachment[],
})

const updateAttachments = (selectedAttachments) => {
  emit('update:attachments', [
    ...props.attachments,
    ...selectedAttachments.map((selectedAttachment) => ({
      id: selectedAttachment.id,
      name: selectedAttachment.name,
    })),
  ])
}

const removeAttachment = (attachmentId) => {
  const localAttachments = [...props.attachments]
  const removeIndex = localAttachments.map((attachment) => attachment.id).indexOf(attachmentId)
  localAttachments.splice(removeIndex, 1)

  emit('update:attachments', localAttachments)
}
</script>

<style scoped lang="scss"></style>
